import React from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';
import LtiCallback from './LtiCallback';
import DevPortal from '../DevPortal/Layouts';
import DevDashboard from '../DevPortal/DevDashboard';
import CourseAnalytics from '../DevPortal/Analytics';
import StudentAnalytics from '../DevPortal/Analytics/StudentAnalytics';
import Dashboard from '../Dashboard';
import DeckGenerator from '../FlashcardDeck/DeckGenerator';
import DeckDetails from '../FlashcardDeck/DeckDetails';
import StudyDeck from '../FlashcardDeck/StudyDeck';
import EditDeck from '../FlashcardDeck/EditDeck';
import DeckLayout from '../FlashcardDeck/DeckLayout';
import QuizGenerator from '../Quizzes/QuizGenerator';
import QuizPage from '../Quizzes/QuizPage';
import QuizEditor from '../Quizzes/QuizEditor';
import SummaryGenerator from '../Summary/SummaryGenerator';
import SummaryDetails from '../Summary/SummaryDetails';
import SummaryLayout from '../Summary/SummaryLayout';
import EditSummary from '../Summary/EditSummary';
import AdminFeedback from '../DevPortal/Feedback';
import RequiresCourseId from './RequiresCourseId';
import IdentityGate from '../Auth/IdentityGate';
import ErrorBoundary from '../common/ErrorBoundary';

const courseRoutes = [
  <Route key="dashboard" index element={<Dashboard />} />,
  <Route key="flashcards" path="flashcards" element={<DeckGenerator />} />,
  <Route key="flashcards-detail" element={<DeckLayout />}>
    <Route key="flashcards-deck" path="flashcards/:deckId" element={<DeckDetails />} />
    <Route key="flashcards-study" path="flashcards/:deckId/study" element={<StudyDeck />} />
    <Route key="flashcards-edit" path="flashcards/:deckId/edit" element={<EditDeck />} />
  </Route>,
  <Route key="quiz" path="quiz" element={<QuizGenerator />} />,
  <Route key="quiz-page" path="quiz/:quizId" element={<QuizPage />} />,
  <Route key="quiz-edit" path="quiz/:quizId/edit" element={<QuizEditor />} />,
  <Route key="summary" path="summary" element={<SummaryGenerator />} />,
  <Route key="summary-detail" element={<SummaryLayout />}>
    <Route path="summary/:summaryId" element={<SummaryDetails />} />
    <Route path="summary/:summaryId/edit" element={<EditSummary />} />
  </Route>,
];

function AppRoutes() {
  return (
    <Routes>
      <Route path="/lti/:session" element={<LtiCallback />}>
        {courseRoutes}
      </Route>
      <Route
        path="/"
        element={
          <IdentityGate>
            <DevPortal />
          </IdentityGate>
        }
      >
        <Route index element={<DevDashboard />} />
        <Route path="analytics">
          <Route index element={<CourseAnalytics />} />
          <Route path=":courseId" element={<StudentAnalytics />} />
        </Route>
        {/*
          Outside courseRoutes on purpose: those are rendered by the Canvas
          shell as well, and reading everyone's feedback is portal-only.
        */}
        <Route path="feedback" element={<AdminFeedback />} />
        <Route
          path="myStudySidekick"
          element={
            <RequiresCourseId>
              <ErrorBoundary>
                <Outlet />
              </ErrorBoundary>
            </RequiresCourseId>
          }
        >
          {courseRoutes}
        </Route>
      </Route>
    </Routes>
  );
}

export default AppRoutes;
